import store from "@/store/store.js";
import axios from "axios";

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  store.dispatch("loadProgressbarAction", true);
  return config;
});

axios.interceptors.response.use(
  (response) => {
    const data = response.data;
    const method = response.config.method;
    if (method !== "get") {
      // setTimeout(() => {
      //   store.dispatch("loadProgressbarAction", false);
      // }, 500);
      if (data.success == true) {
        if (data.message) {
          if (data.message != "Mesafeli Satış Sözleşmesi Getirildi.") store.dispatch("loadSnackbarSuccess", data.message);
        } else store.dispatch("loadSnackbarSuccess", data);
      } else {
        if (data.message) store.dispatch("loadSnackbarError", data.message);
        else store.dispatch("loadSnackbarError", data);
      }
    }
    // setTimeout(() => {
    //   store.dispatch("loadProgressbarAction", false);
    // }, 500);
    store.dispatch("loadProgressbarAction", false);
    return response;
  },

  (error) => {
    const err = error.response.data ? error.response.data : error.response;
    setTimeout(() => {
      store.dispatch("loadProgressbarAction", false);
    }, 500);
    if (err.status === 401 || err.StatusCode === 401 || error.response.status === 401) {
      store.dispatch("auth/loadLogout");
    } else {
      if (err.message || err.Message) store.dispatch("loadSnackbarError", err.message ? err.message : err.Message);
      else store.dispatch("loadSnackbarError", err);
    }
  }
);

export default axios;
